export function drawSphereArcherProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(16, 185, 129, 0.85)';
  ctx.shadowBlur = size * 0.24;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.31, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(16, 185, 129, 0.92)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.14, size * 0.17, Math.PI, Math.PI * 2);
  ctx.fillStyle = 'rgba(6, 95, 70, 0.95)';
  ctx.fill();
  ctx.lineWidth = size * 0.03;
  ctx.strokeStyle = 'rgba(110, 231, 183, 0.95)';
  ctx.beginPath();
  ctx.arc(centerX + size * 0.18, centerY + size * 0.02, size * 0.12, -Math.PI * 0.7, Math.PI * 0.7);
  ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(centerX + size * 0.08, centerY - size * 0.06);
  ctx.lineTo(centerX + size * 0.2, centerY + size * 0.09);
  ctx.strokeStyle = 'rgba(245, 245, 245, 0.85)';
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.08, size * 0.05, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(240, 253, 250, 0.96)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.105, size * 0.024, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(2, 6, 23, 0.95)';
  ctx.fill();
  ctx.restore();
}

export function drawSphereMageProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(139, 92, 246, 0.85)';
  ctx.shadowBlur = size * 0.24;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.3, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(124, 58, 237, 0.92)';
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(centerX, centerY - size * 0.35);
  ctx.lineTo(centerX + size * 0.16, centerY - size * 0.06);
  ctx.lineTo(centerX - size * 0.16, centerY - size * 0.06);
  ctx.closePath();
  ctx.fillStyle = 'rgba(76, 29, 149, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.22, centerY + size * 0.08, size * 0.045, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(196, 181, 253, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX + size * 0.22, centerY + size * 0.08, size * 0.02, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.07, size * 0.05, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(243, 232, 255, 0.96)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.095, size * 0.024, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(2, 6, 23, 0.95)';
  ctx.fill();
  ctx.restore();
}

export function drawSphereKnightProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(148, 163, 184, 0.85)';
  ctx.shadowBlur = size * 0.24;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.3, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(100, 116, 139, 0.92)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.07, size * 0.2, Math.PI, Math.PI * 2);
  ctx.fillStyle = 'rgba(71, 85, 105, 0.96)';
  ctx.fill();
  ctx.strokeStyle = 'rgba(226, 232, 240, 0.9)';
  ctx.lineWidth = size * 0.028;
  ctx.beginPath();
  ctx.moveTo(centerX, centerY - size * 0.27);
  ctx.lineTo(centerX, centerY + size * 0.08);
  ctx.stroke();
  ctx.beginPath();
  ctx.rect(centerX - size * 0.24, centerY - size * 0.05, size * 0.12, size * 0.16);
  ctx.fillStyle = 'rgba(148, 163, 184, 0.88)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.04, size * 0.045, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(248, 250, 252, 0.95)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.06, size * 0.022, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(15, 23, 42, 0.95)';
  ctx.fill();
  ctx.restore();
}

export function drawSphereBruteProcedural(
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation: number = 0
): void {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(centerX, centerY);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.translate(-centerX, -centerY);
  ctx.shadowColor = 'rgba(245, 158, 11, 0.85)';
  ctx.shadowBlur = size * 0.24;
  ctx.beginPath();
  ctx.arc(centerX, centerY, size * 0.33, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(217, 119, 6, 0.92)';
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(centerX - size * 0.15, centerY - size * 0.28);
  ctx.lineTo(centerX - size * 0.05, centerY - size * 0.38);
  ctx.lineTo(centerX + size * 0.02, centerY - size * 0.24);
  ctx.closePath();
  ctx.fillStyle = 'rgba(120, 53, 15, 0.94)';
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(centerX + size * 0.15, centerY - size * 0.28);
  ctx.lineTo(centerX + size * 0.05, centerY - size * 0.38);
  ctx.lineTo(centerX - size * 0.02, centerY - size * 0.24);
  ctx.closePath();
  ctx.fillStyle = 'rgba(120, 53, 15, 0.94)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY + size * 0.03, size * 0.1, 0, Math.PI);
  ctx.lineTo(centerX - size * 0.1, centerY + size * 0.03);
  ctx.fillStyle = 'rgba(17, 24, 39, 0.94)';
  ctx.fill();
  for (let i = -1; i <= 1; i += 1) {
    ctx.beginPath();
    ctx.moveTo(centerX + i * size * 0.035, centerY + size * 0.03);
    ctx.lineTo(centerX + i * size * 0.035 + size * 0.015, centerY + size * 0.085);
    ctx.lineTo(centerX + i * size * 0.035 - size * 0.015, centerY + size * 0.085);
    ctx.closePath();
    ctx.fillStyle = 'rgba(255, 237, 213, 0.95)';
    ctx.fill();
  }
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.08, size * 0.05, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(255, 251, 235, 0.96)';
  ctx.fill();
  ctx.beginPath();
  ctx.arc(centerX, centerY - size * 0.105, size * 0.024, 0, Math.PI * 2);
  ctx.fillStyle = 'rgba(15, 23, 42, 0.95)';
  ctx.fill();
  ctx.restore();
}
